import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

export interface WavesTabExtraContextValue {
  tabExtra: ReactNode;
  setTabExtra: (node: ReactNode) => void;
}

export const WavesTabExtraContext = createContext<WavesTabExtraContextValue>({
  tabExtra: null,
  setTabExtra: () => {},
});

export function WavesTabExtraProvider({ children }: { children: ReactNode }) {
  const [tabExtra, setTabExtra] = useState<ReactNode>(null);

  return (
    <WavesTabExtraContext.Provider value={{ tabExtra, setTabExtra }}>
      {children}
    </WavesTabExtraContext.Provider>
  );
}

type TabExtraContent = ReactNode | (() => ReactNode);

/** Register toolbar content shown to the right of wave route tabs. */
export function useWavesTabExtraContent(
  content: TabExtraContent,
  deps: unknown[],
  active = true,
) {
  const { setTabExtra } = useContext(WavesTabExtraContext);

  useEffect(() => {
    if (!active) {
      return undefined;
    }
    setTabExtra(typeof content === 'function' ? content() : content);
    return () => setTabExtra(null);
  }, [...deps, active]);
}
